import { render, staticRenderFns } from "./screenCoach.vue?vue&type=template&id=64560517&scoped=true&"
import script from "./screenCoach.vue?vue&type=script&lang=ts&"
export * from "./screenCoach.vue?vue&type=script&lang=ts&"
import style0 from "./screenCoach.vue?vue&type=style&index=0&id=64560517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64560517",
  null
  
)

export default component.exports